import { Stack, Title } from '@mantine/core'
import { ContactTab } from '@/pages/website/index'

export default function ContactPage() {
  return (
    <Stack>
      <Title order={2}>Холбоо барих</Title>
      <ContactTab />
    </Stack>
  )
}
